export let hrms19xColumns = () => {
  let indexColumns = [{
    key: 'codempid',
    name: '',
    labelCodapp: 'HRMS19XC1',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_codempid',
    name: '',
    labelCodapp: 'HRMS19XC1',
    labelIndex: '71',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codpos',
    name: '',
    labelCodapp: 'HRMS19XC1',
    labelIndex: '72',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codcomp',
    name: '',
    labelCodapp: 'HRMS19XC1',
    labelIndex: '73',
    style: 'min-width: 200px;'
  }, {
    key: 'dtework',
    name: '',
    labelCodapp: 'HRMS19XC1',
    labelIndex: '100',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'typwork',
    name: '',
    labelCodapp: 'HRMS19XC1',
    labelIndex: '110',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'codshift',
    name: '',
    labelCodapp: 'HRMS19XC1',
    labelIndex: '120',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'scheduleTime',
    name: '',
    labelCodapp: 'HRMS19XC1',
    labelIndex: '130',
    class: 'align-center',
    style: 'min-width: 200px;',
    headerRow: 1,
    colspan: 2,
    rowspan: 1
  }, {
    key: 'timstrtw',
    name: '',
    labelCodapp: 'HRMS19XC1',
    labelIndex: '140',
    class: 'align-center',
    style: 'min-width: 100px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1
  }, {
    key: 'timendw',
    name: '',
    labelCodapp: 'HRMS19XC1',
    labelIndex: '150',
    class: 'align-center',
    style: 'min-width: 100px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1
  }, {
    key: 'actualTime',
    name: '',
    labelCodapp: 'HRMS19XC1',
    labelIndex: '160',
    class: 'align-center',
    style: 'min-width: 120px;',
    headerRow: 1,
    colspan: 2,
    rowspan: 1
  }, {
    key: 'timin',
    name: '',
    labelCodapp: 'HRMS19XC1',
    labelIndex: '170',
    class: 'align-center',
    style: 'min-width: 100px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1
  }, {
    key: 'timout',
    name: '',
    labelCodapp: 'HRMS19XC1',
    labelIndex: '180',
    class: 'align-center',
    style: 'min-width: 100px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1
  }, {
    key: 'checkinTime',
    name: '',
    labelCodapp: 'HRMS19XC1',
    labelIndex: '320',
    class: 'align-center',
    style: 'min-width: 120px;',
    headerRow: 1,
    colspan: 2,
    rowspan: 1
  }, {
    key: 'timinc',
    name: '',
    labelCodapp: 'HRMS19XC1',
    labelIndex: '170',
    class: 'align-center',
    style: 'min-width: 100px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1
  }, {
    key: 'timoutc',
    name: '',
    labelCodapp: 'HRMS19XC1',
    labelIndex: '180',
    class: 'align-center',
    style: 'min-width: 100px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1
  }, {
    key: 'abnormal',
    name: '',
    labelCodapp: 'HRMS19XC1',
    labelIndex: '190',
    class: 'align-center',
    style: 'min-width: 300px;',
    headerRow: 1,
    colspan: 3,
    rowspan: 1
  }, {
    key: 'qtylate',
    name: '',
    labelCodapp: 'HRMS19XC1',
    labelIndex: '200',
    class: 'align-center',
    style: 'min-width: 100px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1
  }, {
    key: 'qtyearly',
    name: '',
    labelCodapp: 'HRMS19XC1',
    labelIndex: '210',
    class: 'align-center',
    style: 'min-width: 100px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1
  }, {
    key: 'qtyabsent',
    name: '',
    labelCodapp: 'HRMS19XC1',
    labelIndex: '220',
    class: 'align-center',
    style: 'min-width: 100px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1
  }, {
    key: 'desc_codchng',
    name: '',
    labelCodapp: 'HRMS19XC1',
    labelIndex: '230',
    style: 'min-width: 200px;'
  }, {
    key: 'qtyleave',
    name: '',
    labelCodapp: 'HRMS19XC1',
    labelIndex: '250',
    style: 'min-width: 200px;'
  }, {
    key: 'overtime',
    name: '',
    labelCodapp: 'HRMS19XC1',
    labelIndex: '260',
    class: 'align-center',
    style: 'min-width: 300px;',
    headerRow: 1,
    colspan: 3,
    rowspan: 1
  }, {
    key: 'ot_before',
    name: '',
    labelCodapp: 'HRMS19XC1',
    labelIndex: '270',
    class: 'align-center',
    style: 'min-width: 100px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1
  }, {
    key: 'ot_during',
    name: '',
    labelCodapp: 'HRMS19XC1',
    labelIndex: '280',
    class: 'align-center',
    style: 'min-width: 100px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1
  }, {
    key: 'ot_after',
    name: '',
    labelCodapp: 'HRMS19XC1',
    labelIndex: '290',
    class: 'align-center',
    style: 'min-width: 100px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1
  }]

  return {
    en: {
      index: indexColumns
    },
    th: {
      index: indexColumns
    }
  }
}
export let hrms19xMaxRowspan = {
  index: 2
}



// WEBPACK FOOTER //
// ./src/assets/columns/hrms19x.js